import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { GridColDef } from '@mui/x-data-grid';

import { IAlertSubscription } from '@cbridge-packages/alert';

import { AlertSettingsEnabledCell } from '../_components/AlertSettingsDataGrid/AlertSettingsEnabledCell';

export const useAlertSettingsGridColDef = () => {
  const { t } = useTranslation();

  const columns: GridColDef<IAlertSubscription>[] = useMemo(
    () => [
      {
        field: 'type',
        headerName: t('text:entity.alert.type.label'),
        flex: 1,
        valueGetter: (value: IAlertSubscription['type']) => t(`text:entity.alert.type.value.${value}`),
      },
      {
        field: 'enabled',
        headerName: t('text:common.field.enabled.label'),
        flex: 0,
        width: 200,
        renderCell: ({ row }) => (
          <AlertSettingsEnabledCell type={row.type} enabled={row.enabled} />
        ),
      },
      {
        field: 'description',
        headerName: t('text:common.field.description.label'),
        flex: 2,
        valueGetter: (_, row: IAlertSubscription) => t(`text:entity.alert.type.valueDescription.${row.type}`),
      },
      {
        field: 'recipients',
        headerName: t('text:entity.alert.recipientEmails.label'),
        flex: 1,
        valueGetter: (value: string[]) => value?.length || 0,
      },
      {
        field: 'cooldownSec',
        headerName: t('text:entity.alert.cooldownSec.label'),
        flex: 1,
      },
    ],
    [t],
  );

  return columns;
};
